<template>
  <div class="winxian-container">
    <HundredItem
      v-for="item in itemList"
      :key="item.articleId"
      :every="item"
      :curcer="item.articleId"
      @itemClick="goDetail"
    ></HundredItem>
    <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
  </div>
</template>

<script>
import HundredItem from "@/components/pager/HundredItem.vue";
import mixin from "@/mixins/scrollPager";
import Scroll from "@/components/paging/scroll";
import { mapState } from "vuex";
export default {
  components: {
    HundredItem,
    Scroll
  },
  mixins: [mixin],
  created() {
    this.getList(this.params);
  },
  computed: {
    ...mapState(["hasLogin", "token"]),
  },
  data() {
    return {
      params: {
        id: this.$route.query.id,
        pageNo: 1,
        pageSize: 10,
        userType: 0,
      },
    };
  },
  methods: {
    async getList(data) {
      this.scrollFlag = true;
      const resp = await this.$apis.hundredServe.getLiteratureList(data);
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      this.isEnd = this.pageNum >= this.total / 10;
    },
    goDetail(e) {
      // 跳转论文详情静态页面首页
      window.open(`${this.$global.SeoUrl}thesisDetail?type=0&id=${e.articleId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.winxian-container {
  background-color: #fff;
  min-height: 700px;
  padding-bottom: 19px;
}
</style>
